export enum CameraPreset {
  DEFAULT = "default",
  FRONT = "front",
  TOP = "top",
  LEFT = "left",
  RIGHT = "right",
}

export enum ScanStatus {
  NOT_CONNECTED,
  CONNECTING,
  CONNECTED_IDLE,
  CONNECTED_SCANNING,
  DISCONNECTED,
}
